import { COP_COMMON_ERROR_MESSAGES } from '../constants/common-error-messages'
import { COP_API_BASE_URL, CURRENT_USER_ENDPOINT } from '../constants/service-endpoints'
import { get } from './http.service'
import { ToastService } from './toast.service'

export type CurrentUser = {
    id?: number
    email?: string
    firstname?: string
    lastname?: string
    isSystemAdmin: boolean
    isGAShieldUser: boolean
    isMultiTenantUser: boolean
    isUserManager: boolean
    isAssignedToAnyTenant?: boolean
    partnerPortalAccess: string
    cspAccess: boolean
    psaAccess: boolean
    defaultAccountId?: string
    state?: string
    roleId?: string | null
    roleName?: string | null
}

const getCurrentUser = async (): Promise<CurrentUser | null> => {
    try {
        return await get<CurrentUser>(`${COP_API_BASE_URL}${CURRENT_USER_ENDPOINT}`)
    } catch (error) {
        const fallbackMessage = COP_COMMON_ERROR_MESSAGES['api-error'].message.replace(
            '{{action}}',
            COP_COMMON_ERROR_MESSAGES['api-error'].action['current-user-loading'],
        )
        const message = error instanceof Error && error.message ? error.message : fallbackMessage
        ToastService.error(message)
        return null
    }
}

export { getCurrentUser }
